const simpleRequestMixin = (Base, action) => class extends Base {
  componentDidMount() {
    this.props[`clear${action}`]();
    if (this.props.location.search) {
      this.props[`request${action}`](this.props.location.query);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      if (nextProps.location.search) {
        this.props[`request${action}`](nextProps.location.query);
      } else {
        this.props[`clear${action}`]();
      }
    }
  }

  componentWillUnmount() {
    this.props[`clear${action}`]();
  }
};

export default simpleRequestMixin;



// WEBPACK FOOTER //
// ./client/app/shared/mixins/simple_request.js